import axios from 'axios';
import { API_URL, axiosConfig } from '../../app/api.js';

const withCredentials = { ...axiosConfig, withCredentials: true };

export const BALANCE_LOGS_PAGE_SIZE = 50;

/**
 * @param {{ limit?: number, offset?: number }} [params]
 */
export const getPartnerBalanceLogs = (params = {}) =>
    axios
        .get(`${API_URL}/partner/balance-logs`, {
            ...withCredentials,
            params: {
                limit: params.limit ?? BALANCE_LOGS_PAGE_SIZE,
                offset: params.offset ?? 0,
            },
        })
        .then((r) => r.data);
